import React from 'react';
import {
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import { DailyScreenViews } from '../models/Statistics';

interface Props {
  data: DailyScreenViews;
  period: 'last7days' | 'last30days';
}

const UserTrafficChart: React.FC<Props> = ({ data, period }) => {
    const chartData = data[period].map((item) => ({
        date: item.date,
        count: Number(item.count),
    }));

    return (
        <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData} margin={{ top: 20, right: 30, bottom: 20, left: 0 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="count" name="Screen Views" stroke="#1A3B40" />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default UserTrafficChart;
